import { darken, getContrastRatio } from '@mui/material/styles';

/** WCAG AA: 4.5:1 for normal text, 3:1 for icons, borders and other non-text UI. */
export const TEXT_CONTRAST = 4.5;
export const UI_CONTRAST = 3;

/**
 * Darkens `color` just enough to reach `minRatio` against every background given.
 * Colors that already pass are returned unchanged, so dark palettes keep their exact brand color.
 */
export function readableOn(color, backgrounds, minRatio = TEXT_CONTRAST) {
  const bgs = Array.isArray(backgrounds) ? backgrounds : [backgrounds];
  const passes = (c) => bgs.every((bg) => getContrastRatio(c, bg) >= minRatio);
  if (passes(color)) return color;
  for (let step = 1; step <= 20; step += 1) {
    const candidate = darken(color, step * 0.05);
    if (passes(candidate)) return candidate;
  }
  return darken(color, 1);
}

/** Text and UI shades of the palette's primary color for use on page and card backgrounds. */
export function primaryShades(colors) {
  const backgrounds = [colors.background, colors.surface];
  return {
    text: readableOn(colors.primary, backgrounds, TEXT_CONTRAST),
    ui: readableOn(colors.primary, backgrounds, UI_CONTRAST),
  };
}
